import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmMessageModalContext } from '../confirm-message-modal/confirm-message-modal.component';
import { ModalHelper } from '@services/modal-helper.service';
import { AppState } from '@app/app.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IUserProfile, ProfileService } from '@ztarmobile/zwp-service-backend-v2';
import { NAME_PATTERN } from '@app/app.config';

export type ChangeNameModalData = {
  user: IUserProfile,
  customClass?: string,
}

@Component({
  selector: 'app-change-name-modal',
  templateUrl: './change-name-modal.component.html',
  styleUrl: './change-name-modal.component.scss'
})
export class ChangeNameModalComponent {
  public nameForm: FormGroup;
  public namePattern: RegExp = new RegExp(NAME_PATTERN);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ChangeNameModalData,
    public dialog: MatDialogRef<ConfirmMessageModalContext>,
    private modalHelper: ModalHelper,
    private appState: AppState,
    private profileService: ProfileService
  ) { }

  ngOnInit(): void {
    this.nameForm = new FormGroup({
      firstName: new FormControl(this.data.user.firstName, [Validators.required, Validators.pattern(this.namePattern)]),
      lastName: new FormControl(this.data.user.lastName, [Validators.required, Validators.pattern(this.namePattern)])
    }
    );
  }

  public updateName() {
    this.nameForm.markAllAsTouched();
    if (this.nameForm.invalid) {
      return;
    }

    this.appState.loading = true;
    const updatedInfo: IUserProfile = {
      firstName: this.nameForm.controls.firstName.value.trim(),
      lastName: this.nameForm.controls.lastName.value.trim(),
    };

    this.profileService.updateUserProfile('v2', updatedInfo).then(() => {
      this.closeDialog({ ...this.data.user, ...updatedInfo });
      this.modalHelper.successModal(
        '',
        'Done',
        'secondary-success-modal no-massage',
        'Name Successfully Updated',
        '',
        'assets/icon/banner-success-icon.svg',
        true,
      );

      this.appState.loading = false;
    }).catch(() => {
      this.modalHelper.failureModal(
        'Your request cannot be processed at this moment. Please try again later.',
        'Retry',
        'secondary-fail-modal',
        'Something Went Wrong!',
        '',
        'assets/icon/circle-error.svg'
      );

      this.appState.loading = false;
    });
  }

  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  closeDialog(res?): void {
    this.beforeClose();
    this.dialog.close(res);
  }

  cancel(): void {
    this.closeDialog(false);
  }
}
